// extracted by mini-css-extract-plugin
module.exports = {"text":"text_text__382S0","label":"text_label__A3Tm2","subtitle":"text_subtitle__3EsjD","strong":"text_strong__3iSOZ","strike":"text_strike__3m0Hv","italic":"text_italic__3WPTT"};